module.exports = __webpack_public_path__ + "img/spy-guide_ar.c7586545.png";